import { FixtureProduct } from './targeting-items.fixture';

export const targetingMenuResults: FixtureProduct[] = [
  {
    incentivioId: 'inc-menu-001',
    externalId: 'ext-id-menu-001',
    extTargetingId: 'ext-menu-001',
    title: 'Lunch Menu',
    productType: 'MENU',
    locationVariationCount: 2,
    priceVariationCount: 4,
    locations: [
      {
        productTitle: 'Lunch Menu',
        incentivioId: 'inc-menu-001',
        externalId: 'ext-id-menu-001',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 9990,
        status: 'ACTIVE',
        productId: 'prod-menu-001',
      },
      {
        productTitle: 'Lunch Menu',
        incentivioId: 'inc-menu-001',
        externalId: 'ext-id-menu-001',
        locationName: 'Uptown Store',
        locationId: 'loc-002',
        price: 9990,
        status: 'ACTIVE',
        productId: 'prod-menu-002',
      },
    ],
  },
  {
    incentivioId: 'inc-menu-002',
    externalId: 'ext-id-menu-002',
    extTargetingId: 'ext-menu-002',
    title: 'Dinner Menu',
    productType: 'MENU',
    locationVariationCount: 3,
    priceVariationCount: 6,
    locations: [
      {
        productTitle: 'Dinner Menu',
        incentivioId: 'inc-menu-002',
        externalId: 'ext-id-menu-002',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 15990,
        status: 'ACTIVE',
        productId: 'prod-menu-003',
      },
      {
        productTitle: 'Evening Menu',
        incentivioId: 'inc-menu-002',
        externalId: 'ext-id-menu-002',
        locationName: 'Uptown Store',
        locationId: 'loc-002',
        price: 18990,
        status: 'ACTIVE',
        productId: 'prod-menu-004',
      },
      {
        productTitle: 'Dinner Menu',
        incentivioId: 'inc-menu-002',
        externalId: 'ext-id-menu-002',
        locationName: 'Airport Store',
        locationId: 'loc-003',
        price: 22990,
        status: 'INACTIVE',
        productId: 'prod-menu-005',
      },
    ],
  },
  {
    incentivioId: 'inc-menu-003',
    externalId: 'ext-id-menu-003',
    extTargetingId: 'ext-menu-003',
    title: 'Breakfast Menu',
    productType: 'MENU',
    locationVariationCount: 2,
    priceVariationCount: 3,
    locations: [
      {
        productTitle: 'Breakfast Menu',
        incentivioId: 'inc-menu-003',
        externalId: 'ext-id-menu-003',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 7990,
        status: 'ACTIVE',
        productId: 'prod-menu-006',
      },
    ],
  },
  {
    incentivioId: 'inc-menu-004',
    externalId: 'ext-id-menu-004',
    extTargetingId: 'ext-menu-004',
    title: 'Happy Hour Menu',
    productType: 'MENU',
    locationVariationCount: 1,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Happy Hour Menu',
        incentivioId: 'inc-menu-004',
        externalId: 'ext-id-menu-004',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 5990,
        status: 'ACTIVE',
        productId: 'prod-menu-007',
      },
    ],
  },
  {
    incentivioId: 'inc-menu-005',
    externalId: 'ext-id-menu-005',
    extTargetingId: 'ext-menu-005',
    title: 'Kids Menu',
    productType: 'MENU',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Kids Menu',
        incentivioId: 'inc-menu-005',
        externalId: 'ext-id-menu-005',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 4990,
        status: 'ACTIVE',
        productId: 'prod-menu-008',
      },
    ],
  },
];

export const targetingMenus = {
  results: targetingMenuResults,
};
